import withRouter from "hoc/withRouter";
import {
  CircularProgress,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import ListPage from "components/ListPage/ListPage";
import stationsService from "services/admin/stationsService";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { FaTrashAlt } from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";

const StationList = () => {
  const orgID = localStorage.getItem("orgID") || "";
  const {
    data: stationsResponse,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["stations", { orgID }],
    queryFn: async () => {
      const response: any = await stationsService.getAll();
      return response.data;
    },
  });

  const handleDelete = async (id: string) => {
    if (!window.confirm("Удалить станцию?")) return;
    await stationsService.delete(id);
    refetch();
  };

  function buildContent() {
    if (isLoading) {
      return (
        <div className="text-center">
          <CircularProgress></CircularProgress>
        </div>
      );
    }
    const rows: any[] = (stationsResponse as any)?.data || [];
    if (rows.length === 0) {
      return (
        <div>Станции отсутствуют. Чтобы добавить станцию, нажмите на кнопку "Добавить" сверху</div>
      );
    }
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell>Название</TableCell>
            <TableCell>Код</TableCell>
            <TableCell>Город</TableCell>
            <TableCell>Филиал</TableCell>
            <TableCell>Действия</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((c: any, index: number) => (
            <TableRow key={c.id}>
              <TableCell>{index + 1}</TableCell>
              <TableCell>{c.name}</TableCell>
              <TableCell>{c.code}</TableCell>
              <TableCell>{c.city}</TableCell>
              <TableCell>{c.branch?.name}</TableCell>
              <TableCell>
                <div className="flex gap-2 items-center">
                  <Link to={`/admin/baggages/stations/edit/${c.id}`}>
                    <FaPencil />
                  </Link>
                  <IconButton color="error" onClick={() => handleDelete(c.id)}>
                    <FaTrashAlt />
                  </IconButton>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  }
  return (
    <ListPage pageTitle="Станции КТЖ" pathToAdd={`/admin/baggages/stations/add`}>
      <div className="m-t-32">{buildContent()}</div>
    </ListPage>
  );
};

export default withRouter(StationList);
